<template>
    <el-form label-position="top" size="mini" class="executor">
        <!-- <el-form-item  v-if="executor.isInitconfig" label="节点任务执行方式">
            <el-radio-group v-model="executor.execType" size="mini" class="exec-type">
                <el-row>
                  <el-col :span="15">
                     <el-radio :label="0">单人：将节点任务发给所有人，待任意1人领取节点任务后，其他人变成任务参与人(能查看但不能处理任务)</el-radio>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="15">
                     <el-radio disabled :label="1">多人：将节点任务同时发给所有执行人，所有人均需要完成</el-radio>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="15">
                     <el-radio disabled :label="2">多人顺序：将节点任务按顺序逐一发给执行人，所有人均需要完成</el-radio>
                  </el-col>
                </el-row>
            </el-radio-group>
        </el-form-item> -->
        <el-form-item label="执行人选取方式">
            <el-tooltip  content="设置常规和会签两种模式，具体情况可查看人员配置说明" effect="light" placement="top">
              <el-radio-group  v-if="executor.isInitconfig" v-model="executor.modeType" size="mini" >
                  <el-radio :label="0">常规</el-radio>
                  <el-radio :label="2">会签</el-radio>
               </el-radio-group> 
             </el-tooltip>
            <!-- <div class="executors" v-if="executor.modeType === 0"> -->
            <div class="executors">
                <span style="width:10%">选择人员：</span>
                <div class="select-executor">
                    <span v-for="(user, index) in executor.executors" :key="user.userId" class="executor-item">
                        {{user.trueName}}
                        <!-- <i v-if="executor.isInitconfig" class="executor-del el-icon-circle-close" @click.stop="handleDeleteUser(index)" title="取消执行人"></i> -->
                        <i class="executor-del el-icon-circle-close" @click.stop="handleDeleteUser(index)" title="取消执行人"></i>
                    </span>
                </div>
            </div>
        </el-form-item>
        <el-form-item v-if="executor.modeType < 2" label="执行人角色配置">
           <el-row>
                <el-col :span="3">
                  <el-tooltip content="任务主要负责人，可以留言和提交文件，可以录入表单数据，可以完成任务并触发流程往下执行" placement="top" effect="light">
                    <el-tag type="success">任务-负责人</el-tag>
                  </el-tooltip>
                </el-col>
                  <el-col :span="20">
                        <el-form-item>
                            <el-tooltip :disabled="!selectedAssigneeUser.selectedUserNames" :content="selectedAssigneeUser.selectedUserNames" effect="light" placement="top">
                              <el-input readonly v-model="selectedAssigneeUser.selectedUserNames" @focus="chooseAssigneeUser" ></el-input>
                            </el-tooltip> 
                        </el-form-item> 
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="3">
                  <el-tooltip content="配合任务负责人完成工作，可以留言和提交文件，可以录入表单数据，但是不能触发流程往下执行" placement="top" effect="light">
                     <el-tag type="info">任务-候选人(抄送)</el-tag>
                  </el-tooltip>
                </el-col>
                  <el-col :span="20">
                     <el-form-item>
                        <el-tooltip :disabled="!selectedCandidateUsers.selectedUserNames" :content="selectedCandidateUsers.selectedUserNames" effect="light" placement="top">
                          <el-input readonly v-model="selectedCandidateUsers.selectedUserNames" @focus="chooseCandidateUser" ></el-input>
                        </el-tooltip> 
                    </el-form-item> 
                </el-col>
            </el-row>
            <!-- <el-row v-if="executor.isInitconfig===false"> -->
            <el-row>
                <el-col :span="3">
                  <el-tooltip content="查看任务详情，可以留言和提交文件，不能录入表单数据，不能触发流程往下执行" placement="top" effect="light">
                     <el-tag>任务-参与人</el-tag>
                  </el-tooltip>
                </el-col>
                  <el-col :span="20">
                    <el-form-item>
                        <el-tooltip :disabled="!selectedParticipantUsers.selectedUserNames" :content="selectedParticipantUsers.selectedUserNames" effect="light" placement="top">
                          <el-input readonly v-model="selectedParticipantUsers.selectedUserNames" @focus="chooseParticipantUser" ></el-input>
                        </el-tooltip> 
                    </el-form-item> 
                </el-col>
            </el-row>
        </el-form-item>
        <el-form-item  v-if="executor.modeType === 2" label="会签人员配置">
           <el-row>
                <el-col :span="3">
                  <el-tooltip content="会签任务负责人，可以留言和提交文件，可以录入表单数据，可以完成任务并触发流程往下执行，这里选择了几个负责人，则当前任务节点就会生成几个任务实例" placement="top" effect="light">
                     <el-tag>任务-会签人员</el-tag>
                  </el-tooltip>
                </el-col>
                  <el-col :span="20">
                    <el-form-item>
                        <el-tooltip :disabled="!selectedCountersignUsers.selectedUserNames" :content="selectedCountersignUsers.selectedUserNames" effect="light" placement="top">
                          <el-input readonly v-model="selectedCountersignUsers.selectedUserNames" @focus="chooseCountersignUser" ></el-input>
                        </el-tooltip> 
                    </el-form-item> 
                </el-col>
            </el-row>
         </el-form-item>
          <el-row  v-if="executor.modeType===2">
                <el-col :span="3">
                  <el-tooltip content="会签任务是否按照选择的负责人顺序进行任务处理，选择是则流程生成任务时按顺序一个一个负责人往下执行，选择否则是同时可以执行会签任务" placement="top" effect="light">
                     <el-tag>是否顺序执行</el-tag>
                  </el-tooltip>
                </el-col>
                <el-col :span="20">
                  <el-form-item >
                      <el-radio-group :disabled="!executor.isInitconfig" v-model="executor.sequential" size="mini" @change="changeSequential">
                        <el-radio :label="false">否</el-radio>
                        <el-radio :label="true">是</el-radio>
                      </el-radio-group>
                  </el-form-item>
              </el-col>
              <el-col :span="3">
                  <el-tooltip content="会签完成比例=完成任务数/总会签任务数。设置该值后，当实际流程执行过程中，当前【会签任务完成数】除以【总会签任务数】的值大于等于当前比例时，标志着本次会签任务执行完成。" placement="top" effect="light">
                     <el-tag>会签完成比例</el-tag>
                  </el-tooltip>
                </el-col>
                <el-col :span="20">
                  <el-form-item >
                      <el-input v-if="executor.sequential"  disabled v-model="executor.completeRate"></el-input>
                      <!-- <el-input :disabled="!executor.isInitconfig" type="number" v-if="!executor.sequential" title="请输入0.1~1范围内数字" placeholder="请输入0.1~1范围内数字" v-model="executor.completeRate"></el-input>-->
                      <el-input-number :disabled="!executor.isInitconfig" v-if="!executor.sequential" title="请输入0.1~1范围内数字" placeholder="请输入0.1~1范围内数字" v-model="executor.completeRate" :precision="1" :step="0.1" :max="1"></el-input-number>
                  </el-form-item>
              </el-col>
        </el-row>
        <el-dialog
          custom-class="user-org-dialog"
          title="选择人员"
          top="4vh"
          width="75%"
          :visible.sync="isShowAssigneeUserOrg"
          append-to-body
        > 
          <UserOrg ref="assigneeUserOrg" :multiple="false" :selectedUser="selectedAssigneeUser" :filterUsers="allSelectedUser"/>
          <span slot="footer" class="dialog-footer">
              <el-button @click="isShowAssigneeUserOrg = false">取 消</el-button>
              <el-button type="primary" @click="assigneeUserConfirmClick">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog
          custom-class="user-org-dialog"
          title="选择人员"
          top="4vh"
          width="75%"
          :visible.sync="isShowCandidateUsersOrg"
          append-to-body
        > 
          <UserOrg ref="candidateUserOrg" :multiple="true" :selectedUser="selectedCandidateUsers" :filterUsers="allSelectedUser"/>
          <span slot="footer" class="dialog-footer">
              <el-button @click="isShowCandidateUsersOrg = false">取 消</el-button>
              <el-button type="primary" @click="candidateUserConfirmClick">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog
          custom-class="user-org-dialog"
          title="选择人员"
          top="4vh"
          width="75%"
          :visible.sync="isShowParticipantUsersOrg"
          append-to-body
        > 
          <UserOrg ref="participantUserOrg" :multiple="true" :selectedUser="selectedParticipantUsers" :filterUsers="allSelectedUser"/>
          <span slot="footer" class="dialog-footer">
              <el-button @click="isShowParticipantUsersOrg = false">取 消</el-button>
              <el-button type="primary" @click="participantUserConfirmClick">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog
          custom-class="user-org-dialog"
          title="选择人员"
          top="4vh"
          width="75%"
          :visible.sync="isShowCountersignUsersOrg"
          append-to-body
        > 
          <UserOrg ref="countersignUserOrg" :multiple="true" :selectedUser="selectedCountersignUsers" :filterUsers="allSelectedUser"/>
          <span slot="footer" class="dialog-footer">
              <el-button @click="isShowCountersignUsersOrg = false">取 消</el-button>
              <el-button type="primary" @click="countersignUserConfirmClick">确 定</el-button>
          </span>
        </el-dialog>
        
    </el-form>
</template>

<script>
    import { getUserList } from '@/data-model';
    import { isEmpty, cloneDeep } from 'lodash';

    export default {
        data () {
            return {
                selectItem: undefined,
                loading: false,
                userList: [],
                candidateUsers: [],
                candidateUsersOld: [],
                // assigneeUsers:[],
                assigneeUser: [],
                participantUsers: [],
                countersignUsers: [],
                userMap: new Map(),
                isInit: false,
                isdisabled: false,
                allSelectedUser: '', // 当前所有选中的人员
                isShowAssigneeUserOrg: false,
                selectedAssigneeUser: {// 选中的任务-负责人
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                isShowCandidateUsersOrg: false,
                selectedCandidateUsers: {// 选中的任务-候选人
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                isShowParticipantUsersOrg: false,
                selectedParticipantUsers: {// 选中的任务-参与人
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                isShowCountersignUsersOrg: false,
                selectedCountersignUsers: {// 会签人员
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                bakExecutors: []
            };
        },
        props: {
            executor: {
                type: Object
            },
            processInstance: {
                type: Object
            }
        },
        computed: {
    
        },
        watch: {
            async 'executor.executors' (newVal, oldVal) {
                this.isInit = false;
                this.userMap = new Map();
                await this._queryUserList('').then((data) => {
                    this.initData();
                }).catch(error => {
                    reject(new Error(error));
                });
            },
            // 'executor.sequential' (newVal, oldVal) {
            //    if (newVal) {
            //        this.executor.completeRate = '1';
            //    } else {
            //        this.executor.completeRate = '0.1';
            //    }
            // },
            'executor.completeRate' (newVal, oldVal) {
                if (newVal === '' || newVal > 1 || newVal < 0) {
                    this.executor.completeRate = '1';
                    this.$message({message: '请输入0.1~1范围内数字', type: 'warning'});
                } else {
                    this.executor.completeRate = newVal;
                }
            },
            'executor.modeType' (newVal, oldVal) {
                this.candidateSelectFields = [];
                this.candidateUsers = [];
                this.assigneeSelectFields = '';
                this.participantSelectFields = [];
                this.participantUsers = [];
                this.countersignSelectFields = [];
                this.countersignUsers = [];
                this.allSelectedUser = '';
                this.userMap = new Map();
                this.executor.executors = [];
                this.executor.assigneeUsers = '';
                this.executor.candidateUsers = '';
                this.executor.participantUsers = '';
                // this.executor.countersignUsers = '';
                // console.log(this.bakExecutors);
                // if (newVal < 2) { // 常规
                //     // if (!isEmpty(this.bakExecutors)) {
                //     this.executor.executors = this.bakExecutors;
                //     // }
                // } else if (newVal === 2) { // 会签
                //     this.bakExecutors = cloneDeep(this.executor.executors);
                // }
                // console.log(this.bakExecutors);
            }
        },
        async created () {
            this.userMap = new Map();
            this.isInit = true;
            await this._queryUserList('').then((data) => {
                this.initData();
            }).catch(error => {
                reject(new Error(error));
            });
            // console.log(this.processInstance);
        },
        methods: {
            changeSequential (value) {
                this.executor.completeRate = '1';
                if (value) {
                    this.executor.completeRate = '1';
                } else {
                    // this.executor.completeRate = '0.1';
                    this.executor.completeRate = '1';
                }
                // console.log(this.executor.completeRate);
            },
            async _queryUserList (userName) {
                let userData = await getUserList({ name: userName });
                let sourceUsers = cloneDeep(userData.data);
                this.userList = [];
                sourceUsers.forEach(item => {
                    if (!this.userMap.has(item.userId) || this.isInit) {
                        this.userList.push(item);
                    }
                });
                return userData.data;
            },
            async handleQueryUser (queryString, cb) {
                let queryUserList;
                // 已经选择的用户id列表
                let selectUserIds = this.executor.executors.map(user => {
                    return user.userId;
                });
                queryUserList = await this._queryUserList(queryString);

                if (queryUserList.length === 0) {
                    cb([]);
                } else {
                    cb(queryUserList.filter(user => {
                        return selectUserIds.indexOf(user.userId) === -1;
                    }).map(item => {
                        item.userId = item.userId;
                        item.value = item.trueName;
                        return item;
                    }));
                }
            },
            handleSelectUser (user) {
                this.executor.executors.push({
                    userId: user.userId,
                    trueName: user.trueName,
                    executionOrder: this.executor.executors.length
                });
                this.selectItem = '';
            },
            handleDeleteUser (index) {
                let delObj = this.executor.executors.splice(index, 1);
                // console.log(delObj[0]);
                this.userMap.delete(delObj[0].userId);
                this.clearSelVal(this.assigneeSelectFields, delObj[0].userId, 1);
                this.clearSelVal(this.candidateSelectFields, delObj[0].userId, 2);
                this.clearSelVal(this.participantSelectFields, delObj[0].userId, 3);
                this.clearSelVal(this.countersignSelectFields, delObj[0].userId, 4);
                this.executor.assigneeUsers = this.assigneeSelectFields;
                if (this.candidateSelectFields) {
                    this.executor.candidateUsers = this.candidateSelectFields.join(',');
                }
                if (this.participantSelectFields) {
                    this.executor.participantUsers = this.participantSelectFields.join(',');
                }
                if (this.countersignSelectFields) {
                    this.executor.countersignUsers = this.countersignSelectFields.join(',');
                }
                this.order();
            },
            order () {
                // 重新设置排序字段，删除元素会造成排序字段不连续
                if (this.executor.executors && Array.isArray(this.executor.executors)) {
                    for (let index = 0, len = this.executor.executors.length; index < len; index++) {
                        this.executor.executors[index].executionOrder = index;
                    }
                }
            },
            initData () {
                this.assigneeSelectFields = '';
                this.selectedAssigneeUser.selectedUserIds = '';
                this.selectedAssigneeUser.selectedUserNames = '';
                this.candidateSelectFields = [];
                this.candidateUsers = [];
                this.selectedCandidateUsers.selectedUserIds = '';
                this.selectedCandidateUsers.selectedUserNames = '';
                this.participantSelectFields = [];
                this.participantUsers = [];
                this.selectedParticipantUsers.selectedUserIds = '';
                this.selectedParticipantUsers.selectedUserNames = '';
                this.countersignUsers = [];
                this.selectedCountersignUsers.selectedUserIds = '';
                this.selectedCountersignUsers.selectedUserNames = '';
                this.allSelectedUser = '';
    
                if (!isEmpty(this.executor.assigneeUsers)) {
                    let user = cloneDeep(this.executor.assigneeUsers);
                    this.assigneeSelectFields = user;
                    this.assigneeUser = this.assigneeSelectFields;
                    this.selectedAssigneeUser.selectedUserIds = user;
                    this.selectedAssigneeUser.selectedUserNames = this.getUserNames(user);
                } else {
                    // this.assigneeSelectFields = '';
                    // this.selectedAssigneeUser.selectedUserIds = '';
                    // this.selectedAssigneeUser.selectedUserNames = '';
                }
                if (!isEmpty(this.executor.candidateUsers)) {
                    this.candidateSelectFields = this.executor.candidateUsers.split(',');
                    this.candidateUsers = this.candidateSelectFields;
                    this.selectedCandidateUsers.selectedUserIds = this.executor.candidateUsers;
                    this.selectedCandidateUsers.selectedUserNames = this.getUserNames(this.candidateUsers);
                } else {
                    // this.candidateSelectFields = [];
                    // this.candidateUsers = [];
                    // this.selectedCandidateUsers.selectedUserIds = '';
                    // this.selectedCandidateUsers.selectedUserNames = '';
                }
                if (!isEmpty(this.executor.participantUsers)) {
                    this.participantSelectFields = this.executor.participantUsers.split(',');
                    this.participantUsers = this.participantSelectFields;
                    this.selectedParticipantUsers.selectedUserIds = this.executor.participantUsers;
                    this.selectedParticipantUsers.selectedUserNames = this.getUserNames(this.participantUsers);
                } else {
                    // this.participantSelectFields = [];
                    // this.participantUsers = [];
                    // this.selectedParticipantUsers.selectedUserIds = '';
                    // this.selectedParticipantUsers.selectedUserNames = '';
                }
                if (!isEmpty(this.executor.countersignUsers)) {
                    this.countersignSelectFields = this.executor.countersignUsers.split(',');
                    this.countersignUsers = this.countersignSelectFields;
                    this.selectedCountersignUsers.selectedUserIds = this.executor.countersignUsers;
                    this.selectedCountersignUsers.selectedUserNames = this.getUserNames(this.countersignUsers);
                } else {
                    // this.countersignSelectFields = [];
                    // this.countersignUsers = [];
                }
                // if (this.executor.modeType === 2 && isEmpty(this.executor.completeRate)) {
                if (this.executor.modeType === 2 && !this.myIsNaN(this.executor.completeRate) && isEmpty(this.executor.completeRate)) {
                    // this.executor.completeRate = '0.1';
                    this.executor.completeRate = '1';
                }
                if (this.executor.executors) {
                    this.executor.executors.forEach(item => {
                        this.userMap.set(item.userId, item.userId);
                    });
                }
            },
            myIsNaN (value) {
                return typeof value === 'number' && !isNaN(value);
            },
            handleChange (selVal) {
                if (Array.isArray(selVal)) {
                    selVal.forEach(item => {
                        this.changeSelVal(item);
                    });
                } else {
                    this.changeSelVal(selVal);
                }
                this.selectItem = '';
            },
            changeSelVal (item) {
                if (!this.userMap.has(item)) {
                    this.userMap.set(item, item);
                    let user = this.getUsers(item);
                    if (user) {
                        this.executor.executors.push({
                            userId: item,
                            trueName: user.trueName,
                            executionOrder: this.executor.executors.length
                        });
                    }
                }
            },
            handleDelete (id) {
                // console.log(id);
                this.userMap.delete(id);
                for (var i = 0; i < this.executor.executors.length; i++) {
                    if (this.executor.executors[i].userId === id) {
                        this.handleDeleteUser(i);
                    }
                }
            },
            handleClear (obj) {
                // console.log(obj);
            },
            handleVisibleChange (flg) {
                if (this.isInit) {
                // console.log(flg);
                    this.isInit = false;
                    this._queryUserList('');
                }
            },
            getUsers (id) {
                let user = this.userList.find((item) => {
                    return item.userId === id;
                });
                return user;
            },
            dealTabDelete (newVal, lastUsers) {
                if (lastUsers) {
                    if (!Array.isArray(lastUsers)) {
                        lastUsers = lastUsers.split(',');
                    }
                    let newString = newVal.join(',');
                    let lastString = lastUsers.join(',');
                    // if (newVal.length < lastUsers.length) {
                    if (newString !== lastString) {
                        for (var i = 0, len = lastUsers.length; i < len; i++) {
                            for (var j = 0, len2 = newVal.length; j < len2; j++) {
                                if (lastUsers[i] === newVal[j]) {
                                    lastUsers.splice(i, 1);
                                }
                            }
                        }
                        lastUsers.forEach(item => {
                            this.handleDelete(item);
                        });
                    }
                }
            },
            clearSelVal (selVal, id, type) {
                if (Array.isArray(selVal)) {
                    for (var i = 0, len = selVal.length; i < len; i++) {
                        if (selVal[i] === id) {
                            selVal.splice(i, 1);
                        }
                    }
                } else {
                    if (selVal === id) {
                        this.assigneeSelectFields = '';
                        this.selectedAssigneeUser.selectedUserIds = '';
                        this.selectedAssigneeUser.selectedUserNames = '';
                    }
                }
            },
            getUserNames (ids) {
                let names = '';
                if (Array.isArray(ids)) {
                    for (var i = 0; i < ids.length; i++) {
                        // console.log(ids[i]);
                        let user = this.getUsers(ids[i]);
                        if (user) {
                            if (isEmpty(names)) {
                                names = user.trueName;
                            } else {
                                names += ',' + user.trueName;
                            }
                        }
                    }
                    // ids.forEach(item => {
                    //    let user = this.getUsers(item);
                    //    if (user) {
                    //        if (isEmpty(names)) {
                    //            names = user.trueName;
                    //        } else {
                    //            names += ',' + user.trueName;
                    //        }
                    //    }
                    // });
                } else {
                    let user = this.getUsers(ids);
                    if (user) {
                        names = user.trueName;
                    }
                }
                return names;
            },
            getAllSelectedUsers (type) {
                if (type === 1) { // 负责人
                    this.allSelectedUser = this.selectedCandidateUsers.selectedUserIds + ',' + this.selectedParticipantUsers.selectedUserIds;
                } else if (type === 2) { // 候选人
                    this.allSelectedUser = this.selectedAssigneeUser.selectedUserIds + ',' + this.selectedParticipantUsers.selectedUserIds;
                } else if (type === 3) { // 参与人
                    this.allSelectedUser = this.selectedAssigneeUser.selectedUserIds + ',' + this.selectedCandidateUsers.selectedUserIds;
                }
                // console.log(this.allSelectedUser);
            },
            chooseAssigneeUser () {
                this.$nextTick(_ => {
                    setTimeout(() => { // 初始化
                        this.$refs.assigneeUserOrg._initPage();
                    }, 0);
                    this.getAllSelectedUsers(1);
                    this.isShowAssigneeUserOrg = true;
                });
            },
            assigneeUserConfirmClick () {
                this.$refs.assigneeUserOrg.setChoosedUser();
                let lastUser = cloneDeep(this.assigneeUser);
                this.assigneeUser = this.selectedAssigneeUser.selectedUserIds;
                this.assigneeSelectFields = this.selectedAssigneeUser.selectedUserIds;
                this.executor.assigneeUsers = this.assigneeUser;
                if (lastUser !== this.selectedAssigneeUser.selectedUserIds) {
                    this.handleDelete(lastUser);
                    this.handleChange(this.assigneeUser);
                }
                this.isShowAssigneeUserOrg = false;
            },
            chooseCandidateUser () {
                this.isShowCandidateUsersOrg = true;
                setTimeout(() => { // 初始化
                    this.$refs.candidateUserOrg._initPage();
                }, 0);
                this.getAllSelectedUsers(2);
            },
            candidateUserConfirmClick () {
                this.$refs.candidateUserOrg.setChoosedUser();
                this.candidateUsers = this.selectedCandidateUsers.selectedUserIds.split(',');
                let lastUsers = cloneDeep(this.executor.candidateUsers);
                let newVal = this.selectedCandidateUsers.selectedUserIds.split(',');
                this.candidateSelectFields = this.candidateUsers;
                this.executor.candidateUsers = this.selectedCandidateUsers.selectedUserIds;
                if (lastUsers !== this.selectedCandidateUsers.selectedUserIds) {
                    this.dealTabDelete(newVal, lastUsers);
                    this.handleChange(this.candidateUsers);
                    this.selectedCandidateUsers.selectedUserNames = this.getUserNames(this.candidateUsers);
                }
                this.isShowCandidateUsersOrg = false;
            },
            chooseParticipantUser () {
                this.isShowParticipantUsersOrg = true;
                setTimeout(() => { // 初始化
                    this.$refs.participantUserOrg._initPage();
                }, 0);
                this.getAllSelectedUsers(3);
            },
            participantUserConfirmClick () {
                this.$refs.participantUserOrg.setChoosedUser();
                this.participantUsers = this.selectedParticipantUsers.selectedUserIds.split(',');
                let lastUsers = cloneDeep(this.executor.participantUsers);
                let newVal = this.selectedParticipantUsers.selectedUserIds.split(',');
                this.participantSelectFields = this.participantUsers;
                this.executor.participantUsers = this.selectedParticipantUsers.selectedUserIds;
                if (lastUsers !== this.selectedParticipantUsers.selectedUserIds) {
                    this.dealTabDelete(newVal, lastUsers);
                    this.handleChange(this.participantUsers);
                    this.selectedParticipantUsers.selectedUserNames = this.getUserNames(this.participantUsers);
                }
                this.isShowParticipantUsersOrg = false;
            },
            chooseCountersignUser () {
                this.isShowCountersignUsersOrg = true;
                setTimeout(() => { // 初始化
                    this.$refs.countersignUserOrg._initPage();
                }, 0);
                // this.getAllSelectedUsers(4);
            },
            countersignUserConfirmClick () { // 选定的会签人员
                this.$refs.countersignUserOrg.setChoosedUser();
                // console.log(this.selectedCountersignUsers);
                this.countersignUsers = this.selectedCountersignUsers.selectedUserIds.split(',');
                let lastUsers = cloneDeep(this.executor.countersignUsers);
                let newVal = this.selectedCountersignUsers.selectedUserIds.split(',');
                this.countersignSelectFields = this.countersignUsers;
                this.executor.countersignUsers = this.selectedCountersignUsers.selectedUserIds;
                this.executor.countersignUsersName = this.selectedCountersignUsers.selectedUserNames;
                if (lastUsers !== this.selectedCountersignUsers.selectedUserIds) {
                    this.dealTabDelete(newVal, lastUsers);
                    this.handleChange(this.countersignUsers);
                    this.selectedCountersignUsers.selectedUserNames = this.getUserNames(this.countersignUsers);
                }
                this.isShowCountersignUsersOrg = false;
            }
    
        }
    };
</script>

<style lang="less">
    .executor {
        .executors {
            display: flex;
            flex-direction: row;
        }
        .executor-del {
            cursor: pointer;
        }
        .select-executor {
            // display: flex;
            flex-direction: row;
        }
        .executor-item {
            margin: 0 6px;
            cursor: pointer;
            &>i {
                // display: none;
                visibility: hidden;
            }
        }
        .executor-item:hover {
            i {
                visibility: visible;
            }
        }
        .executor-input {
            width: 90px;
        }
    }
    .userClass{
        width: 500px;                 
    }
</style>



// WEBPACK FOOTER //
// src/pages/process/ProcessEditor/components/ExecutorEdit.vue